import { render } from "./alert.html?vue&type=template&id=ba6f9a3a&scoped=true&ts=true"
import script from "./alert.ts?vue&type=script&lang=ts"
export * from "./alert.ts?vue&type=script&lang=ts"

import "./alert.scss?vue&type=style&index=0&id=ba6f9a3a&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba6f9a3a"]])

export default __exports__